export const docInfoHR = {

    "report_id":"ID izvještaja:",

    //Informacije o dokumentu
    "document_information": "Informacije o dokumentu",
    "document_name": "Naziv dokumenta:",
    "report_generation_time": "Vrijeme izdavanja izvještaja:",
    "num_of_signatures": "Broj potpisa ili pečata:",
    "report_avalible_on": "Izvještaj dostupan na:",
    "report_avalible_until": "Izvještaj dostupan do:",
    "signature_status": "Oznaka statusa potpisa ili pečata:",
    "signatures_status": "Oznake statusa potpisa ili pečata:",

    //Potpisi / pečati
    "signatures":"Informacije o potpisu ili pečatu",
    "signature_seal_id":"ID potpisa ili pečata:",

    //
    "diagnostic_report":"Dijagnostički izvještaj o provedenoj validaciji"
}